import { useAutoneTranslation } from '@autone/translations';

import { Button } from '../../../../atoms';
import { useAdvancedFiltersContext } from '../AdvancedFilters.context';
import { advancedFilterConditionIsComplete } from '../utilities/reducer-utils';

interface ClearAllButtonProps {
  id: string;
  className?: string;
}

export const ClearAllButton = ({ id, className }: ClearAllButtonProps) => {
  const { common } = useAutoneTranslation();
  const { state, dispatch } = useAdvancedFiltersContext();

  const hasAnyFiltersSelected = Object.values(state.conditions).some(
    advancedFilterConditionIsComplete,
  );

  return (
    <Button
      id={id}
      aria-label={common('clear-all')}
      className={className}
      variant="ghost"
      disabled={!hasAnyFiltersSelected}
      onClick={() => dispatch({ type: 'RESET' })}
    >
      {common('clear-all')}
    </Button>
  );
};
